import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/attachment.svg'


const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 mr-3",
  alt: "attachment"
}, null, -1)
const _hoisted_3 = { class: "text-gray-lp-300" }
const _hoisted_4 = { class: "absolute opacity-50 w-full h-full inset-0 flex items-center justify-center z-60 rounded bg-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_ctx.fileName)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileName || _ctx.name ? _ctx.$refs.file.click() : () => {})),
        onDragover: _cache[2] || (_cache[2] = e => _ctx.setDragAndDrop(e, true)),
        onDragleave: _cache[3] || (_cache[3] = e => _ctx.setDragAndDrop(e, false)),
        onDrop: _cache[4] || (_cache[4] = e => _ctx.onSubmitDrag(e)),
        class: 
        `
      ${_ctx.isDragFile ? 'border-gray-lp-600 bg-gray-lp-100' : 'border-gray-lp-400 relative'}
      items-center text-12px justify-between flex flex-row cursor-pointer border-2 border-dashed py-2 px-4 rounded my-2`
      
      }, [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.ellipsisString(_ctx.fileName.toString()) || _ctx.name.toString()), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Icons, {
            name: "trash-concentrated",
            class: "w-4 cursor-pointer"
          })
        ])
      ], 34))
    : _createCommentVNode("", true)
}